import { render, staticRenderFns } from "./icon-sabbath.vue?vue&type=template&id=63f9c38b&scoped=true"
var script = {}
import style0 from "./icon-sabbath.vue?vue&type=style&index=0&id=63f9c38b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9c38b",
  null
  
)

export default component.exports